<template>
  <b-container fluid="">
    <b-row v-if="role === 'sales_manager'">
      <b-col>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title d-inline">Filter by user</h4>
          </template>
          <template v-slot:body>
            <v-select
              multiple
              :closeOnSelect="false"
              v-model="selectedUserIds"
              :reduce="(user) => user.id"
              label="email"
              :options="users"
            ></v-select>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-row>
          <b-col xl="12">
            <b-row>
              <b-col sm="12">
                <iq-card>
                  <template v-slot:body>
                    <b-row>
                      <b-col>
                        <div class="d-flex align-items-center mb-3 mb-lg-0">
                          <div
                            class="
                              rounded-circle
                              iq-card-icon iq-bg-primary
                              mr-3
                            "
                          >
                            <i class="ri-mail-open-line"></i>
                          </div>
                          <div class="text-left">
                            <h4 data-cy="activities-total">{{ aggregation.total | notAvailable }}</h4>
                            <p class="mb-0">Total activities</p>
                          </div>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="d-flex align-items-center mb-3 mb-lg-0">
                          <div
                            class="rounded-circle iq-card-icon iq-bg-info mr-3"
                          >
                            <i class="ri-message-3-line"></i>
                          </div>
                          <div class="text-left">
                            <h4 data-cy="activities-leads-changed">
                              {{ aggregation.stageChanges | notAvailable }}
                            </h4>
                            <p class="mb-0">Leads changed</p>
                          </div>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="d-flex align-items-center mb-3 mb-lg-0">
                          <div
                            class="
                              rounded-circle
                              iq-card-icon iq-bg-danger
                              mr-3
                            "
                          >
                            <i class="ri-mail-open-line"></i>
                          </div>
                          <div class="text-left">
                            <h4 data-cy="activities-emails-sent">{{ aggregation.emails | notAvailable }}</h4>
                            <p class="mb-0">Emails sent</p>
                          </div>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="d-flex align-items-center mb-3 mb-md-0">
                          <div
                            class="
                              rounded-circle
                              iq-card-icon iq-bg-warning
                              mr-3
                            "
                          >
                            <i class="ri-task-line"></i>
                          </div>
                          <div class="text-left">
                            <h4 data-cy="activities-campaigns-sent">
                              {{ aggregation.campaigns | notAvailable }}
                            </h4>
                            <p class="mb-0">Campaigns sent</p>
                          </div>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="d-flex align-items-center mb-3 mb-md-0">
                          <div
                            class="
                              rounded-circle
                              iq-card-icon iq-bg-warning
                              mr-3
                            "
                          >
                            <i class="ri-task-line"></i>
                          </div>
                          <div class="text-left">
                            <h4 data-cy="activities-clicks">{{ aggregation.clicks | notAvailable }}</h4>
                            <p class="mb-0">Clicks</p>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </template>
                </iq-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4>Activity</h4>
          </template>
          <template v-slot:body>
            <apexchart
              v-if="chartData"
              height="350"
              type="line"
              :options="chartData.options"
              :series="chartData.series"
            ></apexchart>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title d-inline">Team</h4>
          </template>
          <template v-slot:body>
            <b-table
                hover
                responsive
                :items="aggregationByOwner"
                :fields="fields"
                class="mb-0 table-borderless"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                sort-icon-left
                striped
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(owner)="data">
                  {{ data.value.email }}
                </template>
                <template v-slot:cell(ownerId)="data">
                  <b-button
                    size="sm"
                    variant="warning"
                    class="mr-2"
                    @click="detailUserId=data.value"
                  >
                    <i class="fa fa-bars mr-0"></i>
                  </b-button>
              </template>
              </b-table>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal
        id="user-campaigns"
        v-if="selectedUserCampaigns"
        :visible="!!detailUserId"
        :title="`Campaigns of user ${selectedUserCampaigns.prettyName}.`"
        @hidden="detailUserId = null"
        hide-footer
        size="xl"
      >
      <b-table
                hover
                responsive
                :items="selectedUserCampaigns.campaigns"
                :fields="userCampaignFields"
                class="mb-0 table-borderless"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:cell(number_of_clicks)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(number_of_opens)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(ctr)="data"
                  >{{ (data.value * 100).toFixed(0) }} %</template
                >
                <template v-slot:cell(open_rate)="data"
                  >{{ (data.value * 100).toFixed(0) }} %</template
                >
                <template v-slot:cell(sent_at)="data">{{
                  data.value | formatDate | notAvailable
                }}</template>
              </b-table>
    </b-modal>
  </b-container>
</template>
<script>
import { core } from "../../config/pluginInit";
import { countBy, groupBy } from "lodash";
import moment from "moment";
import DeletedBadge from "./Components/DeletedBadge";
import gql from "graphql-tag";
import IqCard from "../../components/core/cards/iq-card.vue";
import ApexChart from "../../components/core/charts/ApexChart.vue";
import { getAccountSync } from "../../Utils/account";
const LIST_EVENTS = gql`
  query listEvents($where: events_bool_exp) {
    events(where: $where) {
      id
      event_type
      created_at
      owner_id
      owner {
        id
        first_name
        last_name
        email
      }
    }
  }
`;
const LIST_AVAILABLE_USERS = gql`
  query {
    users(where: { role: { _eq: sales_person } }) {
      id
      email
      first_name
      last_name
    }
  }
`;
const LIST_CAMPAIGNS_OF_USER = gql`
  query listCampaignsOfUser($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      first_name
      last_name
      email
    }
    campaigns(where: {
      owner_id: {
        _eq: $userId
      }
    }, order_by: {
      sent_at: desc_nulls_last
    }) {
      id
      name
      audience
      number_of_clicks
      number_of_opens
      ctr
      open_rate
      sent_at    
    }
  }
`;
function eventTypeToGroup(eventType) {
  switch (eventType) {
    case "CAMPAIGN_COMPLETED":
      return "campaigns";
    case "EMAIL_CLICKED":
      return "clicks";
    case "EMAIL_OPENED":
      return "opens";
    case "EMAIL_SENT":
      return "emails";
    case "LEAD_STAGE_CHANGED":
      return "stageChanges";
    case "":
      return "other";
    default:
      return "system";
  }
}

function groupToLabel(group) {
  switch (group) {
    case "campaigns":
      return "Campaigns sent";
    case "clicks":
      return "Clicks";
    case "opens":
      return "Opens";
    case "emails":
      return "Emails sent";
    case "stageChanges":
      return "Leads changed";
    default:
      return "Other";
  }
}

function prettyName(user) {
  if (user.first_name || user.last_name) {
      return `${user.first_name || ""} ${user.last_name || ""} (${user.email})`;
  } else {
        return user.email;
  }
}

export default {
  name: "AnalyticsActivity",
  components: {
    IqCard,
    DeletedBadge,
    ApexChart
  },
  data() {
    return {
      events: [],
      timeSlots: [],
      series: {},
      selectedUserIds: [],
      users: [],
      role: getAccountSync()?.defaultRole,
      sortBy: "ownerId",
      sortAsc: true,
      detailUserId: null,
      userCampaignFields: [
        { key: "name", title: "Name", sortable: true },
        { key: "audience", title: "Audience", sortable: true },
        { key: "number_of_clicks", label: "Clicks", sortable: true },
        { key: "number_of_opens", label: "Opens", sortable: true },
        { key: "ctr", label: "CTR", sortable: true },
        { key: "open_rate", label: "OR", sortable: true },
        { key: "sent_at", label: "Sent at", sortable: true },
      ],
      fields: [
        { key: "owner", label: "Name", sortable: true },
        { key: "total", label: "Total", sortable: true },
        { key: "stageChanges", label: "Leads changed", sortable: true },
        { key: "emails", label: "Emails sent", sortable: true },
        { key: "campaigns", label: "Campaigns sent", sortable: true },
        { key: "clicks", label: "Clicks", sortable: true },
        { key: "opens", label: "Opens", sortable: true },
        { key: "ownerId", label: "Campaigns", sortable: false }
      ],
    };
  },
  apollo: {
    events: {
      query: LIST_EVENTS,
      variables() {
        return {
          where: this.eventsFilter
        };
      },
      update: data => {
        const remapped = data.events.map(e => ({
          ...e,
          group: eventTypeToGroup(e.event_type)
        }));
        return remapped;
      }
    },
    users: {
      query: LIST_AVAILABLE_USERS
    },
    selectedUserCampaigns: {
      query: LIST_CAMPAIGNS_OF_USER,
      variables() {
        return {
          userId: this.detailUserId
        }
      },
      update: data => {
          if (!data) {
            return {}
          }
          return {
            ...data,
            prettyName: prettyName(data.users_by_pk),
          };
      }
    }
  },
  computed: {
    chartData() {
      if (this.events.length > 0) {
        const minDay = _.minBy(this.events, function(o) {
          return o.created_at;
        });
        const firstDay = moment(minDay.created_at).startOf("day");
        const nOfDays = moment().diff(firstDay, "days");
        const timeSlots = [];
        timeSlots[0] = firstDay.format("YYYY-MM-DD");
        for (let index = 1; index <= nOfDays; index++) {
          timeSlots[index] = moment(firstDay)
            .subtract(-index, "days")
            .format("YYYY-MM-DD");
        }

        // group events
        const groupedEvents = groupBy(this.events, e => e.group);
        const keys = Object.keys(groupedEvents);
        const series = [];
        keys.forEach(k => {
          if (k === "system") {
            return;
          }
          var group = _.groupBy(groupedEvents[k], function(i) {
            return moment(i.created_at)
              .startOf("day")
              .format();
          });
          // console.log("group timestamps: ", group);
          const serie = new Array(timeSlots.length).fill(0);
          const groupKeys = Object.keys(group);
          // console.log("groupKeys: ", groupKeys);
          groupKeys.forEach(gk => {
            // console.log("searching index of", gk);
            const idx = timeSlots.indexOf(moment(gk).format("YYYY-MM-DD"));
            // console.log("found idx", idx);
            if (idx !== -1) {
              serie[idx] = group[gk].length;
            }
          });
          series.push({
            name: groupToLabel(k),
            data: serie
          });
        });

        return {
          options: {
            chart: {
              id: "activity"
            },
            stroke: {
              curve: "smooth"
            },
            xaxis: {
              categories: timeSlots
            }
          },
          series: series
        };
      }
    },
    aggregation() {
      if (this.events) {
        const aggregation = countBy(this.events, e => e.group);
        const keys = Object.keys(aggregation);
        let total = 0;
        keys.forEach(k => {
          if (!["system"].includes(k)) {
            total += aggregation[k];
          }
        });
        aggregation["total"] = total;
        return aggregation;
      }
    },
    aggregationByOwner() {
      if (this.events) {
        const eventsByOwner = groupBy(this.events, e => e.owner_id);
        const ownerIds = Object.keys(eventsByOwner);
        let eventsAggregationByOwner = ownerIds.map(id => {
          const eventTypeCounts = countBy(eventsByOwner[id], e => e.group);
          const total =
            (eventTypeCounts["campaigns"] || 0) +
            (eventTypeCounts["clicks"] || 0) +
            (eventTypeCounts["opens"] || 0) +
            (eventTypeCounts["emails"] || 0) +
            (eventTypeCounts["stageChanges"] || 0);
          return {
            ownerId: id,
            owner: eventsByOwner[id][0].owner,
            ...countBy(eventsByOwner[id], e => e.group),
            total
          };
        });
        // add users with no data
        this?.users.forEach(user => {
          if (
            eventsAggregationByOwner.findIndex(i => i.ownerId === user.id) ===
            -1
          ) {
            eventsAggregationByOwner.push({
              campaigns: 0,
              emails: 0,
              clicks: 0,
              opens: 0,
              stageChanges: 0,
              system: 0,
              total: 0,
              ownerId: user.id,
              owner: user
            });
          }
        });
        // filter our non owner id groups
        const aggregationByOwnerNotSystem = eventsAggregationByOwner.filter(
          i => {
            // if not owner defined
            if (i.owner === null) {
              return false;
            }
            // if user filter activated check if in it
            if (
              this.selectedUserIds.length > 0 &&
              !this.selectedUserIds.includes(i.ownerId)
            ) {
              return false;
            }
            return true;
          }
        );

        return aggregationByOwnerNotSystem;
      }
    },
    eventsFilter() {
      if (this.selectedUserIds.length > 0) {
        return { owner_id: { _in: this.selectedUserIds } };
      } else {
        return {};
      }
    },
  },
  mounted() {
    core.index();
  }
};
</script>
